<template>
  <div :class="(showTickets && 'ticketList', isZkm && 'ticketListZkm')">
    <div>
      <div v-if="loading" style="width: 100%">
        <div class="skeleton-container">
          <vue-skeleton-loader rounded radius="8" width="100%" height="76.8px" animation="fade" />
        </div>
        <div class="skeleton-container">
          <vue-skeleton-loader rounded radius="8" width="100%" height="76.8px" animation="fade" />
        </div>
        <vue-skeleton-loader
          rounded
          radius="8"
          width="100%"
          height="98px"
          animation="fade"
          style="margin-top: 2rem"
        />
        <vue-skeleton-loader
          rounded
          radius="8"
          width="100%"
          height="98px"
          animation="fade"
          style="margin-top: 2rem"
        />
      </div>
      <div v-else-if="showHeader && showTickets" style="margin-bottom: 2.5rem">
        <module-title color="#333333" :title="getTitle" :font-style="!isZkm && titleStyle" />
        <div v-if="showRemainingTicketsChip" class="remaining-tickets-chip">
          <span>{{ $t('remainingSeats') }}</span>
          <span class="remaining-tickets-chip__count">
            <img src="/assets/tickets-chip.svg" alt="">
            {{ numOfRemainingTickets }}
          </span>
        </div>
      </div>
      <div class="title-description mb-32 mt-12">
        {{ styles.titleDescription || 'Ovdje možeš kupiti jednu ili više karata' }}
      </div>
      <div v-if="selectedAccessibleTicketCount > 0" class="accessible-info-banner">
        <v-icon size="24" color="#0277BD">info_outline</v-icon>
        <span>{{ $t('accessibleTicketInfo') }}</span>
      </div>
      <v-dialog v-model="escortDialogOpen" max-width="360" persistent>
        <div class="escort-dialog-content">
          <p class="escort-dialog-question">{{ $t('escortQuestion') }}</p>
          <div class="escort-dialog-actions">
            <main-button
              flat
              :text="$t('escortNo')"
              color="#333333"
              @click="onEscortDialogAnswer(false)"
            />
            <main-button
              :text="$t('escortYes')"
              color="#333333"
              @click="onEscortDialogAnswer(true)"
            />
          </div>
        </div>
      </v-dialog>
      <div>
        <div v-if="!showTickets && !loading" class="no-tickets">
          <img :src="getModalImage" alt="no tickets" style="align-self: center">
          <module-title
            color="#333333"
            :title="getModalTitle"
            :description="getModalDescription"
            :show-events-button="true"
            :show-ticket-swap-button="event.soldOut && !event.canceled"
            :event="event"
            class="pb-4"
            style="align-self: center"
          />
          <div v-if="event.canceled && event.cancellationNotification" class="cancel-notification">
            <div>{{ $t('organizerMessage') }}:</div>
            <div v-html="event.cancellationNotification" />
          </div>
        </div>
        <div v-else-if="categories.length">
          <div
            v-for="[organizationItemCategoryId, orderItems] in categories"
            :key="categories.id"
            style="margin-bottom: 1rem"
          >
            <div
              v-if="
                !checkIfAllTicketsInCategorySoldOut(organizationItemCategoryId) ||
                  getOrganizationItemCategory(organizationItemCategoryId).displayIfSoldOut
              "
              :style="{
                background: getOrganizationItemCategory(organizationItemCategoryId).color + '14',
                color: getOrganizationItemCategory(organizationItemCategoryId).color,
                border:
                  '1px solid ' +
                  getOrganizationItemCategory(organizationItemCategoryId).color +
                  '80',
              }"
              class="organization-item-category-container"
            >
              <div class="category-container-header">
                <p class="category-name">
                  {{ getOrganizationItemCategory(organizationItemCategoryId).name }}
                </p>
                <p
                  v-if="getOrganizationItemCategory(organizationItemCategoryId).description"
                  class="category-description"
                  style="margin: 0"
                >
                  {{ getOrganizationItemCategory(organizationItemCategoryId).description }}
                </p>
              </div>
              <template v-if="!isZkm">
                <ticket-card
                  v-for="orderItem in orderItems"
                  :ticket="orderItem"
                  :event="event"
                  :promo-code="promoCode"
                  :items="selectedTicket"
                  style="width: 100%"
                  :can-add-more="canAddMoreCheck(orderItem)"
                  active-background-color="white"
                  :color="getOrganizationItemCategory(organizationItemCategoryId).color"
                  is-part-of-category
                  @added="addTicketToCart"
                  @removed="removeTicketToCart"
                />
              </template>
              <template v-else>
                <ticket-card-zkm
                  v-for="orderItem in orderItems"
                  :ticket="orderItem"
                  :event="event"
                  :promo-code="promoCode"
                  :items="selectedTicket"
                  style="width: 100%"
                  :can-add-more="canAddMoreCheck(orderItem)"
                  active-background-color="white"
                  :color="getOrganizationItemCategory(organizationItemCategoryId).color"
                  is-part-of-category
                  @added="addTicketToCart"
                  @removed="removeTicketToCart"
                />
              </template>
            </div>
          </div>
          <div
            v-for="orderItem in withoutCategories"
            :key="orderItem.id"
            style="padding: 0 1.5rem"
            class="no-categories-container"
          >
            <template v-if="!isZkm">
              <ticket-card
                :ticket="orderItem"
                :event="event"
                :promo-code="promoCode"
                :items="selectedTicket"
                :can-add-more="canAddMoreCheck(orderItem)"
                color="#333333"
                style="margin-bottom: 1rem"
                background-color="#3333330d"
                active-background-color="white"
                @added="addTicketToCart"
                @removed="removeTicketToCart"
              />
            </template>
            <template v-else>
              <ticket-card-zkm
                :ticket="orderItem"
                :event="event"
                :promo-code="promoCode"
                :items="selectedTicket"
                :can-add-more="canAddMoreCheck(orderItem)"
                color="#333333"
                style="margin-bottom: 1rem"
                background-color="#3333330d"
                active-background-color="white"
                @added="addTicketToCart"
                @removed="removeTicketToCart"
              />
            </template>
          </div>
        </div>
        <div v-else>
          <div v-for="item in items" :key="item.id" class="mb-32">
            <p v-if="titlesMap[item.id]" class="title-map-style">{{ titlesMap[item.id] }}</p>
            <template v-if="!isZkm">
              <ticket-card
                :key="item.quantity"
                :ticket="item"
                :event="event"
                :promo-code="promoCode"
                :items="selectedTicket"
                :can-add-more="canAddMoreCheck(item)"
                color="#333333"
                style="margin-bottom: 1rem"
                background-color="#3333330d"
                active-background-color="white"
                @added="addTicketToCart"
                @removed="removeTicketToCart"
              />
            </template>
            <template v-else>
              <ticket-card-zkm
                :ticket="item"
                :event="event"
                :promo-code="promoCode"
                :items="selectedTicket"
                :can-add-more="canAddMoreCheck(item)"
                :color="eventColor"
                :background-color="getThemeStyle(event.coverImagePrimaryColor, 0.05, 'primary')"
                @added="addTicketToCart"
                @removed="removeTicketToCart"
              />
            </template>
          </div>
        </div>
      </div>
      <div v-if="isZkm" id="zkm-svg-container">
        <p class="svg-description">Dostupnost ulaznica</p>
        <svg id="zkm-svg" />
      </div>
      <v-snackbar
        v-if="styles.required || snackbarOpen"
        v-model="snackbarOpen"
        bottom
        right
        color="primary"
        :timeout="2500"
      >
        <span>{{
          snackbarMessage || styles.snackbarText || 'Potrebno je odabrati barem jednu kartu'
        }}</span>
      </v-snackbar>
      <div v-if="isZkm" class="attendee-actions attendee-modals-zkm">
        <main-button
          id="backButton"
          class="back-btn"
          flat
          :text="styles.goBack || $t('back')"
          color="#333333"
          @click="goToMainPage"
        />
        <main-button
          id="continuePurchaseButton"
          :disabled="!selectedTicket.length"
          class="purchase-btn"
          depressed
          :text="styles.purchase || $t('continueShopping')"
          color="#333333"
          @click="$emit('next')"
        />
        <router-link
          v-if="seeTickets && lastOrderId"
          target="_blank"
          :to="{
            name: routes.ungrouped.ticketPdf,
            params: { orderId: lastOrderId, purchaseIndex: 'all' },
          }"
        >
          Pogledaj karte
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import ModuleTitle from './../../shared/module-title.vue'
import { GET_ONLINE_ORDER_ITEMS } from '@/graphql/orderItem.graphql'
import TicketCard from '../../tickets/ticket-card'
import { isDateBetween, landingURL } from '@/utils'
import moment from 'moment'
import TicketCardZkm from '@/components/tickets/ticket-card-zkm.vue'
import { MembershipTicketsPerEventLimitByOrganizationId } from '@/types'

const initialSeatColors = Object.freeze({
  AVAILABLE: '#979797',
  SELECTED: '#4DAFBB',
  UNAVAILABLE: '#f5f5f5',
  UNAVAILABLE_BORDER: '#d9d9d9',
})
export default {
  components: {
    TicketCardZkm,
    TicketCard,
    ModuleTitle,
  },
  props: {
    preserveHeldSelection: { type: Boolean, default: false },
    managedRegister: { type: Boolean, default: false },
    saleTime: { type: String, default: null },
    inventoryEnabled: { type: Boolean, default: true },
    initialPromoCode: {
      type: String,
      default: null,
    },
    showHeader: {
      type: Boolean,
      default: true,
    },
    event: {
      type: Object,
      default: null,
    },
    requiredTicketsPerCategory: {
      type: Number,
      default: null,
    },
    maxPackages: {
      type: Number,
      default: 5,
    },
    selected: {
      type: Array,
      default: () => [],
    },
    styles: {
      type: Object,
      default: () => ({}),
    },
    updatedOrderItems: {
      type: Object,
      default: () => ({}),
    },
    initialValues: {
      type: Array,
      default: () => [],
    },
    color: {
      type: String,
      default: '#333333',
    },
    seeTickets: {
      type: Boolean,
      default: false,
    },
    lastOrderId: {
      type: String,
      default: null,
    },
    promoCode: {
      type: Object,
      default: null,
    },
    numOfRemainingTickets: {
      type: Number,
      default: 0,
    },
    showRemainingTicketsChip: {
      type: Boolean,
      default: false,
    },
    membership: {
      type: Object,
      default: null,
    },
    orderItemAccessCode: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      eventColor: this.event.eventTemplateId
        ? '#333'
        : this.getThemeStyle(this.event.coverImagePrimaryColor, null, 'primary'),
      items: [],
      showTickets: this.numOfRemainingTickets > 0,
      ticketsSoldOut: false,
      selectedItem: {
        type: Array,
        default: () => [],
      },
      disabledItem: [],
      allOrganizationItemCategories: [],
      snackbarOpen: false,
      snackbarMessage: '',
      allAvailableTickets: null,
      escortDialogOpen: false,
      pendingEscortAccessibleTicket: null,
      startingSeatId: this.event.audienceCapacity,
      selectedTicket: this.initialValues || [],
      selectPromo: false,
      numberOfAvailableTickets: this.numOfRemainingTickets,
      bundleOfferUsages: {},
      titlesMap: {
        1142: 'MOTOVUN 22.7.',
        1151: 'MOTOVUN 23.7.',
        1155: 'MOTOVUN 24.7.',
        1161: 'PETEHOVAC 26.7.',
        1162: 'PETEHOVAC 27.7.',
        1168: 'PETEHOVAC 28.7.',
        1174: 'PETEHOVAC 29.7.',
        1089: 'AUTOBUS',
      },
      secondaryColor: '#FF4C00',
      zkmColor: '#333333',
      categories: [],
      withoutCategories: [],
      titleStyle: {
        fontFamily: 'Raleway',
        fontSize: '2.25rem',
        fontStyle: 'normal',
        fontWeight: '800',
        lineHeight: '120%',
        letterSpacing: '-0.0675rem',
      },
      loading: true,
    }
  },
  computed: {
    totalTicketsSelected() {
      return this.selectedTicket.length
    },
    isZkm() {
      return this.event.organization.id == process.env.VUE_APP_ZKM_ORGANIZATION_ID
    },
    membershipTicketsPerEventLimit() {
      const organizationId = Number(this.event && this.event.organization && this.event.organization.id)
      const limit = MembershipTicketsPerEventLimitByOrganizationId[organizationId]

      return typeof limit === 'number' ? limit : null
    },
    membershipTicketLimit() {
      if (!this.membership || !this.membership.membershipPlan) {
        return 0
      }

      const membershipAmount = Number(this.membership.membershipPlan.amount) || 0

      return typeof this.membershipTicketsPerEventLimit === 'number'
        ? Math.min(membershipAmount, this.membershipTicketsPerEventLimit)
        : membershipAmount
    },
    selectedMembershipTicketCount() {
      return this.selectedTicket.filter(ticket => ticket && ticket.membership).length
    },
    selectedAccessibleTicketCount() {
      return this.selectedTicket.filter(
        ticket => ticket && ticket.itemMeta && ticket.itemMeta.isAccessible,
      ).length
    },
    getTitle() {
      const availableTickets = this.getAvailableTickets(this.items)
      const allAvailableTicketAreFree = availableTickets.every(ticket => Number(ticket.price) === 0)
      if (allAvailableTicketAreFree) {
        return this.$t('downloadTickets')
      }

      return this.styles.apply || this.$t('buyATicket')
    },
    getModalTitle() {
      if (this.event.canceled) {
        return this.$t('eventCanceled')
      }

      if (this.ticketsSoldOut) {
        return this.$t('ticketSoldOut')
      }

      return this.$t('ticketUnavailable')
    },
    getModalDescription() {
      if (this.event.canceled) {
        if (Number(this.event.id) === 3375) {
          return ''
        }

        return this.$t('eventCanceledDescription')
      }

      if (this.ticketsSoldOut) {
        return this.$t('ticketSoldOutDescription')
      }

      if (this.event && this.event.organization && this.event.organization.id === 502) {
        return ''
      }

      return this.$t('ticketUnavailableDescription')
    },
    getModalImage() {
      if (this.event.canceled) {
        return '/assets/sad-ticket.svg'
      }

      if (this.ticketsSoldOut) {
        return '/assets/sad-ticket.svg'
      }

      return '/assets/dont-know-ticket.svg'
    },
  },
  apollo: {
    getOnlineOrderItems: {
      query: GET_ONLINE_ORDER_ITEMS,
      variables() {
        return {
          eventId: this.event.id,
          accessCode: this.orderItemAccessCode,
        }
      },
      skip() {
        return this.managedRegister || this.numOfRemainingTickets <= 0
      },
      manual: true,
      result({ loading, data }) {
        if (loading) {
          return
        }

        if (!data) {
          this.loading = false

          return
        }

        const { getOnlineOrderItems = [], getEventAndOrganization } = data

        if (getEventAndOrganization) {
          this.numOfRemainingTickets = getEventAndOrganization.numOfRemainingTickets
        }
        this.allAvailableTickets = getOnlineOrderItems.filter(
          val => this.isWithinSaleTime(val) && val.quantity > 0,
        )
        const availableTickets = this.getAvailableTickets(getOnlineOrderItems)
        const unavailableTickets = this.getUnavailableTickets(getOnlineOrderItems)
        this.items = [...availableTickets, ...unavailableTickets]
        this.initialComputeOrderItems({})
        this.showTickets = this.items.length > 0
      },
    },
  },
  watch: {
    'event.coverImagePrimaryColor'() {
      if (this.managedRegister && !this.event.eventTemplateId) this.eventColor = this.getThemeStyle(this.event.coverImagePrimaryColor, null, 'primary')
    },
    snackbarOpen(current) {
      if (!current) {
        this.snackbarMessage = ''
      }
    },
    selectedTicket: function () {
      this.$emit('selectedTickets', this.selectedTicket)
    },
    updatedOrderItems: function () {
      this.initialComputeOrderItems(this.updatedOrderItems)
    },
    membership: function () {
      if (!this.membership) {
        const numOfSeatsToRemove = this.selectedTicket.length - this.initialValues.length
        this.selectedTicket = this.initialValues
        this.items = this.items.filter(i => !i.membership)
        if (this.isZkm) {
          for (let i = 1; i <= numOfSeatsToRemove; i++) {
            this.changeSvgSeatColor(
              (this.startingSeatId + (this.initialValues.length + i)).toString(),
              initialSeatColors.AVAILABLE,
            )
          }
        }
      }
    },
  },
  methods: {
    isWithinSaleTime(ticket) {
      if (!this.managedRegister || !this.saleTime) return isDateBetween(ticket)

      return Date.parse(ticket.from) <= Date.parse(this.saleTime) && Date.parse(ticket.to) >= Date.parse(this.saleTime)
    },
    async refreshRegisterInventory() {
      if (!this.managedRegister || !this.inventoryEnabled || this.preserveHeldSelection) return
      const request = this._registerInventoryRequest = (this._registerInventoryRequest || 0) + 1
      const eventId = this.event.id
      const accessCode = this.orderItemAccessCode
      const saleTime = this.saleTime
      const { data, errors } = await this.$apollo.query({
        query: GET_ONLINE_ORDER_ITEMS, fetchPolicy: 'no-cache', errorPolicy: 'none', variables: { eventId, accessCode },
      })
      if (this._isDestroyed || request !== this._registerInventoryRequest || eventId !== this.event.id ||
        accessCode !== this.orderItemAccessCode || saleTime !== this.saleTime || !this.inventoryEnabled || this.preserveHeldSelection) return
      if (errors || !data || !Array.isArray(data.getOnlineOrderItems)) throw new Error('Ticket data unavailable')
      const rows = data.getOnlineOrderItems
      this.allAvailableTickets = rows.filter(ticket => this.isWithinSaleTime(ticket) && ticket.quantity > 0 &&
        (!ticket.itemMeta || !ticket.itemMeta.accessCode || ticket.itemMeta.accessCode === this.orderItemAccessCode))
      const membershipIds = this.membership ? this.items.filter(ticket => ticket.membership).map(ticket => ticket.id) : []
      this.items = [...this.getAvailableTickets(rows), ...this.getUnavailableTickets(rows),
        ...this.allAvailableTickets.filter(ticket => ticket.membership && membershipIds.includes(ticket.id))]
      const quantities = {}
      const previous = this.selectedTicket
      // Reconcile paid rows first: gratis entitlement derives from fresh paid quantity.
      const paid = previous.filter(ticket => !ticket.bundleOfferId).reduce((selected, ticket) => {
        const fresh = this.allAvailableTickets.find(row => String(row.id) === String(ticket.id))
        const changedEscort = ticket.itemMeta && ticket.itemMeta.isEscort &&
          (!fresh || !fresh.itemMeta || !fresh.itemMeta.isEscort || Number(fresh.price) !== 0)
        if (fresh && !changedEscort && (quantities[fresh.id] || 0) < Number(fresh.quantity)) {
          quantities[fresh.id] = (quantities[fresh.id] || 0) + 1
          selected.push({ ...ticket, ...fresh })
        }

        return selected
      }, [])
      const gratisCounts = {}
      const usages = {}
      for (const ticket of this.allAvailableTickets) usages[ticket.id] = 0
      const gratis = previous.filter(ticket => ticket.bundleOfferId).reduce((selected, ticket) => {
        const fresh = this.allAvailableTickets.find(row => String(row.id) === String(ticket.id))
        const bundle = fresh && fresh.bundleOffer
        if (!bundle || String(bundle.id) !== String(ticket.bundleOfferId)) return selected
        const interval = Number(bundle.quantityInterval)
        const freeQuantity = Number(bundle.freeQuantity)
        const quota = Math.max(0, Math.floor(Number(bundle.availableQuantity) || 0))
        const allowed = interval > 0 && freeQuantity > 0
          ? Math.min(Math.floor((quantities[fresh.id] || 0) / interval), quota) * freeQuantity : 0
        const count = gratisCounts[fresh.id] || 0
        if (count < allowed && (quantities[fresh.id] || 0) + count < Number(fresh.quantity)) {
          gratisCounts[fresh.id] = count + 1
          usages[fresh.id] = Math.ceil((count + 1) / freeQuantity)
          selected.push({ ...ticket, ...fresh, price: 0, bundleOfferId: bundle.id })
        }

        return selected
      }, [])
      this.bundleOfferUsages = usages
      this.selectedTicket = [...paid, ...gratis]
      this.pruneUnpairedEscortTickets()
      if (this.pendingEscortAccessibleTicket) {
        const fresh = this.allAvailableTickets.find(ticket => String(ticket.id) === String(this.pendingEscortAccessibleTicket.id))
        if (!fresh || !this.canAddEscortFor(fresh)) {
          this.pendingEscortAccessibleTicket = null
          this.escortDialogOpen = false
        } else this.pendingEscortAccessibleTicket = fresh
      }
      const changedPrices = this.selectedTicket.some(ticket => {
        const old = previous.find(value => value.id === ticket.id && value.bundleOfferId === ticket.bundleOfferId)

        return old && Number(old.price) !== Number(ticket.price)
      })
      if (this.selectedTicket.length !== previous.length || changedPrices) {
        this.snackbarMessage = this.$t('registerSelectionChanged')
        this.snackbarOpen = true
      }
      this.numberOfAvailableTickets = this.numOfRemainingTickets
      this.initialComputeOrderItems({})
      this.showTickets = this.items.length > 0
    },
    initialComputeOrderItems(updatedOrderItems) {
      if (this.items.length) {
        for (const [key, value] of Object.entries(updatedOrderItems)) {
          if (!key) {
            continue
          }
          const oi = this.items.find(oi => oi.id === key)
          const quantityDifference =
            this.selectedTicket.filter(t => t.id === key).length - value.quantity
          for (let i = 0; i < quantityDifference; i++) {
            const index = this.selectedTicket.indexOf(i => i.id === key)
            this.selectedTicket.splice(index, 1)
          }
          oi.quantity = value.quantity
        }
        if (this.event.organization.type !== 'THEATER') {
          this.ticketsSoldOut = this.event.soldOut
        } else {
          this.ticketsSoldOut = this.event.soldOut
        }

        this.allOrganizationItemCategories = []
        this.withoutCategories = []

        const orderItemsByCategory = {}
        for (const ticket of this.items) {
          if (ticket.organizationItemCategory) {
            this.allOrganizationItemCategories.push(ticket.organizationItemCategory)
            if (orderItemsByCategory[ticket.organizationItemCategory.id]) {
              orderItemsByCategory[ticket.organizationItemCategory.id].push(ticket)
            } else {
              orderItemsByCategory[ticket.organizationItemCategory.id] = [ticket]
            }
          } else {
            this.withoutCategories.push(ticket)
          }
        }
        this.categories = Object.entries(orderItemsByCategory)
          .sort(([, a], [, b]) => {
            return a[0].organizationItemCategory.priority - b[0].organizationItemCategory.priority
          })
          .map(c => [c[0], c[1].sort((a, b) => b.createdAt - a.createdAt)])
      }
      this.allOrganizationItemCategories = [...new Set(this.allOrganizationItemCategories)]
      this.loading = false
    },
    getOrganizationItemCategory(id) {
      return this.allOrganizationItemCategories.find(c => c.id === id)
    },
    drawSvg() {
      const svgn = 'http://www.w3.org/2000/svg'
      const svg = document.getElementById('zkm-svg')
      let cy = 25
      let cx = 25
      let j = 0
      let height = 150
      const containerWidth = document.getElementById('zkm-svg').clientWidth - cx
      for (let i = 0; i <= this.event.audienceCapacity; i++) {
        j += 1
        25 * j > containerWidth && (j = 1) && (cy += 25) && (height += 45)
        const circle = document.createElementNS(svgn, 'circle')
        circle.setAttributeNS(null, 'id', i.toString())
        circle.setAttributeNS(null, 'cx', (cx * j).toString())
        circle.setAttributeNS(null, 'cy', cy.toString())
        circle.setAttributeNS(null, 'r', '10')
        circle.setAttributeNS(
          null,
          'fill',
          i <= this.event.audienceCapacity - this.numOfRemainingTickets
            ? initialSeatColors.UNAVAILABLE
            : initialSeatColors.AVAILABLE,
        )
        svg.appendChild(circle)
      }
      document.getElementById('zkm-svg-container').style.height = `${height}px`
      !this.showTickets && (document.getElementById('zkm-svg-container').style.display = 'none')
    },
    triggerButtonClick() {
      this.$el.querySelector('#continuePurchaseButton').click()
    },
    canAddMoreCheck(ticket) {
      if (this.requiredTicketsPerCategory) {
        if (!ticket.organizationItemCategory) {
          return false
        }

        const selectedInCategory = this.selectedTicket.filter(
          selected =>
            selected.organizationItemCategory &&
            String(selected.organizationItemCategory.id) ===
              String(ticket.organizationItemCategory.id),
        ).length
        if (selectedInCategory >= this.requiredTicketsPerCategory * this.maxPackages) {
          return false
        }
      }

      if (
        this.promoCode &&
        typeof this.promoCode.remainingTickets === 'number' &&
        this.promoCode.orderItems.some(orderItem => orderItem.id === ticket.id)
      ) {
        const selectedPromoTicketCount = this.selectedTicket.filter(selectedTicket =>
          this.promoCode.orderItems.some(orderItem => orderItem.id === selectedTicket.id),
        ).length
        if (selectedPromoTicketCount >= this.promoCode.remainingTickets) {
          return false
        }
      }

      if (this.membership && ticket.membership) {
        return this.selectedMembershipTicketCount < this.membershipTicketLimit
      }
      const boughtTicketAmount = this.items.reduce((acc, curr) => {
        return (acc += curr.initialQuantity - parseInt(curr.quantity))
      }, 0)
      let currTicketNumber = this.selectedTicket.filter(t => t.id === ticket.id).length
      const maxTicketsPerOrder = this.requiredTicketsPerCategory
        ? this.categories.length * this.requiredTicketsPerCategory * this.maxPackages
        : this.event.eventTemplateId
          ? 10
          : ((this.event.flags && this.event.flags.ticketsPerOrder) || 10)

      return this.event.eventTemplateId
        ? this.totalTicketsSelected < maxTicketsPerOrder &&
            this.numberOfAvailableTickets - this.totalTicketsSelected !== 0 &&
            this.totalTicketsSelected + boughtTicketAmount < this.event.audienceCapacity &&
            (ticket.itemMeta && ticket.itemMeta.max ? currTicketNumber < ticket.itemMeta.max : true)
        : this.totalTicketsSelected < maxTicketsPerOrder &&
            (ticket.itemMeta && ticket.itemMeta.max ? currTicketNumber < ticket.itemMeta.max : true)
    },
    getUnavailableTickets(allTickets) {
      return allTickets
        .filter(val => !(val.itemMeta && val.itemMeta.isEscort))
        .filter(val => {
          if (this.managedRegister && Date.parse(val.from) > Date.parse(this.saleTime)) return false
          const now = this.managedRegister && this.saleTime ? this.saleTime : new Date()
          if (val.quantity <= 0 || moment(val.to).isBefore(now)) {
            if (val.organizationItemCategory) {
              return val.organizationItemCategory.displayIfSoldOut
            }

            return val.showIfSold
          }

          return false
        })
        .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
    },
    getAvailableTickets(allTickets) {
      return allTickets
        .filter(
          val =>
            this.isWithinSaleTime(val) &&
            val.quantity > 0 &&
            !val.membership &&
            !(val.itemMeta && val.itemMeta.isEscort),
        )
        .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
    },
    changeSvgSeatColor(id, color) {
      document.getElementById(id).setAttributeNS(null, 'fill', color)
    },
    applyBundleOffer(ticket) {
      if (!ticket.bundleOffer || ticket.bundleOffer.availableQuantity <= 0) {
        return
      }

      const ticketId = ticket.id
      const usageSoFar = this.bundleOfferUsages[ticketId] || 0
      const maxUsage = ticket.bundleOffer.availableQuantity

      const currentCountForTicket = this.selectedTicket.filter(t => t.id === ticketId).length
      const freeTicketsSoFar = this.managedRegister
        ? this.selectedTicket.filter(t => t.id === ticketId && t.bundleOfferId).length
        : usageSoFar * ticket.bundleOffer.freeQuantity
      const paidCountForTicket = Math.max(currentCountForTicket - freeTicketsSoFar, 0)
      const possibleUsage = Math.floor(paidCountForTicket / ticket.bundleOffer.quantityInterval)
      const newUsage = Math.min(possibleUsage, maxUsage)
      const additionalFreeTickets = newUsage * ticket.bundleOffer.freeQuantity - freeTicketsSoFar
      let autoAddedFreeTickets = 0

      if (additionalFreeTickets > 0) {
        for (let i = 0; i < additionalFreeTickets; i++) {
          if (!this.canAddMoreCheck(ticket)) {
            break
          }
          this.selectedTicket.push({
            ...ticket,
            price: 0,
            bundleOfferId: ticket.bundleOffer.id,
          })
          autoAddedFreeTickets++
        }
      } else if (additionalFreeTickets < 0) {
        const freebiesToRemove = -additionalFreeTickets
        let removed = 0
        for (
          let idx = this.selectedTicket.length - 1;
          idx >= 0 && removed < freebiesToRemove;
          idx--
        ) {
          if (this.selectedTicket[idx].id === ticketId && this.selectedTicket[idx].bundleOfferId) {
            this.selectedTicket.splice(idx, 1)
            removed++
          }
        }
      }

      const retainedUsage = this.managedRegister
        ? Math.ceil(this.selectedTicket.filter(t => t.id === ticketId && t.bundleOfferId).length / ticket.bundleOffer.freeQuantity)
        : newUsage
      if (retainedUsage !== usageSoFar) {
        this.bundleOfferUsages = {
          ...this.bundleOfferUsages,
          [ticketId]: retainedUsage,
        }
      }

      if (autoAddedFreeTickets > 0) {
        this.snackbarMessage = this.$t('bundleOfferGratisAdded', { count: autoAddedFreeTickets })
        this.snackbarOpen = true
      }
    },
    // every accessible ticket type has its own free escort ("Pratnja") item sharing its template
    escortOrderItemFor(accessibleTicket) {
      if (!accessibleTicket || !accessibleTicket.orderItemTemplateId) {
        return null
      }

      return (
        (this.allAvailableTickets || []).find(
          ticket =>
            ticket.itemMeta &&
            ticket.itemMeta.isEscort &&
            String(ticket.orderItemTemplateId) === String(accessibleTicket.orderItemTemplateId),
        ) || null
      )
    },
    countSelectedById(ticketId) {
      return this.selectedTicket.filter(ticket => ticket && String(ticket.id) === String(ticketId))
        .length
    },
    canAddEscortFor(accessibleTicket) {
      const escortTicket = this.escortOrderItemFor(accessibleTicket)

      // no remaining capacity for the escort → the question is not even asked
      return (
        !!escortTicket &&
        this.canAddMoreCheck(escortTicket) &&
        this.countSelectedById(escortTicket.id) < this.countSelectedById(accessibleTicket.id)
      )
    },
    maybeAskForEscort(ticket) {
      if (!ticket.itemMeta || !ticket.itemMeta.isAccessible) {
        return
      }
      if (!this.canAddEscortFor(ticket)) {
        return
      }
      this.pendingEscortAccessibleTicket = ticket
      this.escortDialogOpen = true
    },
    onEscortDialogAnswer(hasEscort) {
      this.escortDialogOpen = false
      const accessibleTicket = this.pendingEscortAccessibleTicket
      this.pendingEscortAccessibleTicket = null
      if (!hasEscort || !accessibleTicket || !this.canAddEscortFor(accessibleTicket)) {
        return
      }
      this.selectedTicket.push(this.escortOrderItemFor(accessibleTicket))
    },
    // an escort ticket only exists alongside the accessible ticket it belongs to
    pruneUnpairedEscortTickets() {
      const findUnpairedEscortIndex = () =>
        this.selectedTicket.findIndex(ticket => {
          if (!ticket || !ticket.itemMeta || !ticket.itemMeta.isEscort) {
            return false
          }
          const accessibleTicket = (this.allAvailableTickets || []).find(
            candidate =>
              candidate.itemMeta &&
              candidate.itemMeta.isAccessible &&
              String(candidate.orderItemTemplateId) === String(ticket.orderItemTemplateId),
          )

          return (
            this.countSelectedById(ticket.id) >
            (accessibleTicket ? this.countSelectedById(accessibleTicket.id) : 0)
          )
        })
      let index = findUnpairedEscortIndex()
      while (index !== -1) {
        this.selectedTicket.splice(index, 1)
        index = findUnpairedEscortIndex()
      }
    },
    addTicketToCart(ticket) {
      if (this.requiredTicketsPerCategory && !this.canAddMoreCheck(ticket)) {
        return
      }

      if (ticket.membership) {
        if (this.selectedMembershipTicketCount < this.membershipTicketLimit) {
          this.selectedTicket.push(ticket)
        }
      } else {
        this.selectedTicket.push(ticket)
      }
      this.applyBundleOffer(ticket)
      this.maybeAskForEscort(ticket)
      this.isZkm &&
        this.changeSvgSeatColor(
          (this.startingSeatId + this.selectedTicket.length).toString(),
          initialSeatColors.SELECTED,
        )
    },
    removeTicketToCart(ticket) {
      // Prefer to remove a paid ticket first; if there is none, fall back to any ticket with this id
      let index = this.selectedTicket.findIndex(
        item => item.id === ticket.id && !item.bundleOfferId,
      )
      if (index === -1) {
        index = this.selectedTicket.findIndex(item => item.id === ticket.id)
      }
      this.isZkm &&
        this.changeSvgSeatColor(
          (this.startingSeatId + this.selectedTicket.length).toString(),
          initialSeatColors.AVAILABLE,
        )
      if (index > -1) {
        this.selectedTicket.splice(index, 1)
      }
      this.pruneUnpairedEscortTickets()
      this.applyBundleOffer(ticket)
    },
    addPromo() {
      return (this.selectPromo = !this.selectPromo)
    },
    applyPromoCode(promoCodeInput) {
      this.$emit('applyPromo', promoCodeInput)
    },
    triggerMembershipClick(membershipNumber) {
      this.applyMembership(membershipNumber)
    },
    triggerRemoveSportMembershipTicket() {
      this.selectedTicket = this.selectedTicket.filter(st => !st.itemMeta.sportMembershipTicket)
      this.items = this.items.map(item => {
        if (item.itemMeta.sportMembershipTicket) {
          item.quantity = 0
        }

        return item
      })
    },
    applyMembership(membershipInput) {
      const membershipTicket = (this.allAvailableTickets || []).find(oi =>
        membershipInput.membershipPlan.orderItemTemplates.some(
          oit => oit.id === parseInt(oi.orderItemTemplateId),
        ),
      )
      if (!membershipTicket) {
        this.snackbarOpen = true
        this.snackbarMessage = this.$t('membershipTicketUnavailable')

        return
      }

      if (!this.items.some(item => item && item.id === membershipTicket.id)) {
        this.items = [...this.items, membershipTicket]
        this.initialComputeOrderItems({})
      }

      this.snackbarOpen = true
      this.snackbarMessage = this.$t('membershipTicketAvailable')
      this.$emit('applyMembership', membershipInput)
    },
    removePromoCode() {
      if (this.membership) {
        this.selectedTicket = this.selectedTicket.filter(
          st =>
            parseInt(st.orderItemTemplateId) !== this.membership.membershipPlan.orderItemTemplateId,
        )
      }
      this.$emit('removePromoCode')
    },
    goToMainPage() {
      window.location.href = `${landingURL}/events/${this.event.slug}`
    },
    checkIfAllTicketsInCategorySoldOut(organizationItemCategoryId) {
      for (const orderItem of this.categories.find(
        item => item[0] === organizationItemCategoryId,
      )[1]) {
        if (orderItem.quantity > 0) {
          return false
        }
      }

      return true
    },
    hasEventFinished() {
      return moment().isAfter(moment(this.event.to))
    },
  },
}
</script>

<style scoped>
.attendee-actions-zkm {
  visibility: hidden;
}

.remaining-tickets-chip {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  margin-top: 0.75rem;
  padding: 0.375rem 0.625rem;
  border-radius: 2rem;
  background: #cee4f2;
  color: #0277bd;
  font-family: 'Source Sans Pro', sans-serif;
  font-size: 0.875rem;
  font-style: normal;
  font-weight: 400;
  line-height: 120%;
}

.remaining-tickets-chip__count {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  font-weight: 600;
  letter-spacing: -0.02625rem;
}

.remaining-tickets-chip__count img {
  width: 0.875rem;
  height: 0.875rem;
}

.accessible-info-banner {
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 0 0 1.5rem;
  padding: 14px;
  border-radius: 8px;
  background: #f0f6fa;
  color: #0277bd;
  font-family: 'Source Sans Pro';
  font-size: 14px;
  font-weight: 400;
  line-height: 1.2;
}

.escort-dialog-content {
  background: white;
  border-radius: 12px;
  padding: 1.5rem;
}

.escort-dialog-question {
  font-family: 'Source Sans Pro';
  font-size: 1.125rem;
  color: #333333;
  margin-bottom: 1.5rem;
}

.escort-dialog-actions {
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
}

.promo-style {
  margin-top: 2rem;
  margin-bottom: 24px;
  display: flex;
  width: 204px;
}

.center-icon {
  font-family: 'Raleway';
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  padding-top: 2px;
  text-transform: uppercase;
  margin-left: 6px;
}

.promoCode-wrapper {
  display: flex;
  flex-direction: row;
  justify-content: left;
}

.no-tickets {
  display: flex;
  flex-direction: column;
  align-items: start;
  margin-bottom: 3rem;
}

.no-tickets img {
  margin: 64px 0 20px;
}

.description {
  font-family: Source Sans Pro;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 20px;
  color: #333333;
  text-align: center;
}

@media screen and (max-width: 415px) {
  .ticketList {
    max-width: 300px;
    margin: 0 auto;
  }

  .ticketListZkm {
    max-width: unset;
  }
}

@media screen and (max-width: 340px) {
  .ticketList {
    max-width: 250px;
    margin: 0 auto;
  }
}

.title-map-style {
  color: rgb(255, 76, 0);
  font-family: Raleway;
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
}

#addPromoCodeText {
  font-family: 'Source Sans Pro';
  font-style: normal;
  font-weight: 400;
  font-size: 12px !important;
  line-height: 15px;
}

.attendee-actions {
  display: flex;
  justify-content: flex-end;
}

@media screen and (max-width: 800px) {
  .attendee-actions {
    flex-direction: column-reverse;
  }
}

#zkm-svg {
  width: 100%;
  height: 100%;
}

.svg-description {
  color: #333;
  font-variant-numeric: lining-nums proportional-nums;
  font-family: Rubik;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
}

.organization-item-category-container {
  display: flex;
  padding: 1.5rem;
  flex-direction: column;
  align-items: flex-start;
  gap: 1.5rem;
  max-width: 50.1875rem;
  margin-bottom: 1.5rem;
  border-radius: 4px;
  @media screen and (max-width: 800px) {
    margin-left: -1.5rem;
    margin-right: -1.5rem;
    border-radius: 0;
    border-left: none !important;
    border-right: none !important;
  }
}

.category-name {
  font-variant-numeric: lining-nums proportional-nums;
  font-family: Raleway;
  font-size: 1.5rem;
  margin: 0;
  font-style: normal;
  font-weight: 600;
  line-height: 120%;
  letter-spacing: -0.045rem;
}

.category-description {
  font-family: Source Sans Pro;
  font-size: 1rem;
  font-style: normal;
  font-weight: 400;
  white-space: pre-line;
  line-height: 150%;
}

.category-container-header {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.5rem;
  align-self: stretch;
}

.no-categories-container {
  max-width: 50.1875rem;
  @media screen and (max-width: 800px) {
    margin-left: -1.5rem;
    margin-right: -1.5rem;
  }
}

.cancel-notification {
  background-color: #fbebed;
  color: #bd2a3c;
  border-radius: 15px;
  padding: 10px;
}

.skeleton-container {
  margin-top: 2rem;
  padding: 4.8rem 1.5rem 1.5rem 1.5rem;
  border-radius: 4px;
  width: 100%;
  background: #dbdbdb;
  border: 1px solid #7e7e7e;
}
</style>
